/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from 'prop-types';
import React from 'react';
import { useReducer } from 'react';
import './style.css';

export const Button = ({
    showIcon = false,
    textLink = 'Button',
    status,
    style,
    className,
    isHomepageCtaBlockButton = false,
    onClick = () => {},
}) => {
    /*
  const [state, dispatch] = useReducer(reducer, {
    status: status || "default",
    style: style || "default",
  });
*/

    let buttonStyle = isHomepageCtaBlockButton
        ? { padding: '4px', float: 'right' }
        : { padding: 'reset' };

    return (
        <button
            className={`button style-${style} status-${status} ${className}`}
            style={buttonStyle}
            onMouseEnter={() => {
                //dispatch("mouse_enter");
            }}
            onClick={() => {
                onClick();
                //dispatch("click");
            }}
            onMouseLeave={() => {
                //dispatch("mouse_leave");
            }}
        >
            <div className="div">
                {['default', 'secondary'].includes(style) && <>{textLink}</>}

                {style === 'link' && (
                    <>
                        <div className="text">{textLink}</div>
                        <div className="rectangle-2" />
                    </>
                )}
            </div>
        </button>
    );
};

function reducer(state, action) {
    if (state.status === 'default' && state.style === 'default') {
        switch (action) {
            case 'mouse_enter':
                return {
                    status: 'hover',
                    style: 'default',
                };
        }
    }

    if (state.status === 'hover' && state.style === 'default') {
        switch (action) {
            case 'mouse_leave':
                return {
                    status: 'default',
                    style: 'default',
                };
        }
    }

    if (state.status === 'default' && state.style === 'link') {
        switch (action) {
            case 'mouse_enter':
                return {
                    status: 'hover',
                    style: 'link',
                };
        }
    }

    if (state.status === 'hover' && state.style === 'link') {
        switch (action) {
            case 'mouse_leave':
                return {
                    status: 'default',
                    style: 'link',
                };
        }
    }

    if (state.status === 'default' && state.style === 'secondary') {
        switch (action) {
            case 'mouse_enter':
                return {
                    status: 'hover',
                    style: 'secondary',
                };
        }
    }

    if (state.status === 'hover' && state.style === 'secondary') {
        switch (action) {
            case 'mouse_leave':
                return {
                    status: 'default',
                    style: 'secondary',
                };

            case 'click':
                return {
                    status: 'active',
                    style: 'secondary',
                };
        }
    }

    return state;
}

Button.propTypes = {
    showIcon: PropTypes.bool,
    textLink: PropTypes.string,
    status: PropTypes.oneOf(['hover', 'active', 'default']),
    style: PropTypes.oneOf(['link', 'secondary', 'default']),
    isHomepageCtaBlockButton: PropTypes.bool,
};
